import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=8b9f61f2"
import script from "./newsletter.vue?vue&type=script&lang=js"
export * from "./newsletter.vue?vue&type=script&lang=js"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=8b9f61f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports